<ul class="flex p-bl-1">
  <li style="white-space: nowrap">
    <span>Claim #</span>
    @if (!isLoading) {
    <span class="text-white">
      <cui-copy-button
        [ariaLabel]="'copy claim number ' + headerData?.claimNumber"
        [dataToCopy]="headerData?.claimNumber"
      >
        <div class="claim-number-container">
          {{ headerData?.claimNumber }}
        </div>
      </cui-copy-button>
    </span>
    } @if (isLoading) {
    <span class="ghost-line">
      <span>Loading</span>
    </span>
    }
  </li>
  <li>
    <span>Insured</span>
    @if (!isLoading) {
    <span class="text-white line-clamp-2" style="max-width: 25rem">{{
      headerData?.insured
    }}</span>
    } @if (isLoading) {
    <span class="ghost-line w-20">
      <span>Loading</span>
    </span>
    }
  </li>
  <li>
    <span>Loss Date</span>
    @if (!isLoading) {
    <span class="text-white">{{ headerData?.dateOfLoss }}</span>
    } @if (isLoading) {
    <span class="ghost-line">
      <span>Loading</span>
    </span>
    }
  </li>
  <li>
    <span>Since Report</span>
    @if (!isLoading) {
    <span class="text-white line-clamp-1">{{
      headerData?.timeSinceReport
    }}</span>
    } @if (isLoading) {
    <span class="ghost-line">
      <span>Loading</span>
    </span>
    }
  </li>
  <li style="min-width: 85px">
    <span style="white-space: nowrap; overflow: hidden">File Owner</span>
    @if (!isFileOwnerLoading && ownerRepSummary) {
    <span>
      <div class="flex flex-wrap">
        <cui-popover align="bottom">
          <button
            class="cui-popover-link header-link"
            cui-popover-trigger
            data-pgr-id="btnHeaderContactCard"
          >
            {{ ownerRepSummary.name }} ({{ ownerRepSummary.code }})
          </button>
          <cla-claim-rep-contact-card-redacted
            [rep]="ownerRepSummary"
            cui-popover-content
          ></cla-claim-rep-contact-card-redacted>
        </cui-popover>
      </div>
    </span>
    } @if (!isFileOwnerLoading && !ownerRepSummary) {
    <span class="text-white">
      {{ ownerRepCode }}
    </span>
    } @if (!isFileOwnerLoading && !ownerRepCode) {
    <span class="text-white"> Unassigned </span>
    } @if (isFileOwnerLoading) {
    <span class="ghost-line w-20">
      <span>Loading</span>
    </span>
    }
  </li>
</ul>
